import { render } from "./emoji_input.vue?vue&type=template&id=463d5435"
import script from "./emoji_input.js?vue&type=script&lang=js"
export * from "./emoji_input.js?vue&type=script&lang=js"

import "./emoji_input.vue?vue&type=style&index=0&id=463d5435&lang=scss"

import exportComponent from "/home/jojo/Documents/aspho-fe-pleromer/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__